<template>
  <div class="d-flex justify-center align-center mt-8">
    <p class="me-2 mb-0">{{ formatNumber(min) }}</p>
    <v-slider
      thumb-label="always"
      color="blue"
      :thumb-size="24"
      :max="max"
      :min="min"
      :value="response"
      :disabled="loading"
      :rules="rules"
      @change="$emit('change', $event)"
    />
    <p class="ms-2 mb-0">
      {{ formatNumber(max) }}
    </p>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ScaleForm',

  props: {
    response: {
      type: Number,
      required: false,
      default: null,
    },

    min: {
      type: Number,
      required: true,
    },

    max: {
      type: Number,
      required: true,
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    // Default to min only when unanswered; a stored 0 is a valid answer.
    if (_.isNil(this.response)) {
      this.$emit('change', this.min)
    }
  },

  methods: {
    formatNumber(n) {
      return Intl.NumberFormat(navigator.language)?.format(n)
    },
  },
}
</script>
